import { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import useAlertModal from "hooks/useAlertModal";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import useDispatch from "hooks/useDispatch";
import { repaymentInsert } from "store/slices/repay/repaySlice";

function RepaySubmit({ onClose }) {
  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false)

  const notify = useNotify();
  const alert = useAlertModal();
  const dispatch = useDispatch();

  const { handleSubmit, watch } = useFormContext();
  const amount = watch("amount");

  const isButtonDisabled = useMemo(() => !amount, [amount]);

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await dispatch(repaymentInsert(data))
      
      alert({
        text: "عملیات با موفقیت انجام شد.",
        variant: "success",
        onClose: onClose,
      });
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false)
  };

  useEffect(() => {}, []);

  return (
    <Grid item xs={12}>
      <LoadingButton
        disabled={isButtonDisabled}
        fullWidth
        variant="contained"
        loading={loading}
        color="success"
        onClick={handleSubmit(onSubmit)}
      >
        تایید
      </LoadingButton>
    </Grid>
  );
}

export default RepaySubmit;
